import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export const ProGate = ({ label, isOwner, isPublic }) => (
  <div className="flex h-full flex-col items-center justify-center p-10 text-center" data-testid="pro-gate">
    <div className="flex h-14 w-14 items-center justify-center rounded-full border border-[#F59E0B]/40 bg-[#F59E0B]/10">
      <Lock className="h-6 w-6 text-[#FBBF24]" />
    </div>
    <p className="mt-5 font-display text-4xl text-[#F3EBDD]">{label} is a LoreRight Pro feature.</p>
    <p className="mt-2 max-w-md text-sm text-[#A8A090]">
      {isPublic ? "This universe's owner hasn't unlocked it yet."
        : isOwner ? "Upgrade to unlock Timelines, Calendars, Maps, Relationships & Family Trees, and Languages for everyone in your universes. Anything you've already made is safe."
        : "Pro features in a shared universe come from the owner's plan. Ask the owner to upgrade to unlock this for everyone."}
    </p>
    {isOwner && !isPublic && (
      <Link to="/pricing" className="mt-6 rounded-full bg-[#F59E0B] px-5 py-2 text-sm font-medium text-[#0B0D10] transition-transform hover:-translate-y-0.5" data-testid="pro-gate-upgrade">
        See Pro plans
      </Link>
    )}
  </div>
);
